import * as svg from "../../../assets/prohibited-icon.svg";

import {iconBuilder} from "./iconBuilder";

const ProhibitedIcon = iconBuilder(svg, "ProhibitedIcon", "0 0 13 13");

export default ProhibitedIcon;
